(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1742],{

/***/ 91742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_lustcollection_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91546);
/* harmony import */ var _styles_lustcollection_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_lustcollection_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _data_home__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44330);





var LustCollection = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(_data_home__WEBPACK_IMPORTED_MODULE_3__/* .homeLinks.lustCollection.schema */ .n.lustCollection.schema)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_lustcollection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().videoResponsive),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_lustcollection_module_scss__WEBPACK_IMPORTED_MODULE_4___default().video_cotainer),
                            dangerouslySetInnerHTML: {
                                __html: _data_home__WEBPACK_IMPORTED_MODULE_3__/* .homeLinks.lustCollection.youtube_iframe */ .n.lustCollection.youtube_iframe
                            }
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LustCollection);


/***/ }),

/***/ 91546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lustcollection":"lustcollection_lustcollection__XacB_","play_icon_section":"lustcollection_play_icon_section__N9j33","play_icon1":"lustcollection_play_icon1__SAkKX","btn_get_started":"lustcollection_btn_get_started__ZIoBW","videoResponsive":"lustcollection_videoResponsive__cdHTW","video_cotainer":"lustcollection_video_cotainer__g3vtm"};

/***/ })

}]);